export default function tenderAnimation(timeline) {
  timeline
    .set(".section-container hr", { xPercent: -200, duration: 22 })
    .set("h1 > span", { yPercent: 100 })
    .set("form", { xPercent: 100, opacity: 0 })
    .to(".section-container hr", { xPercent: 0 })
    .to("h1 > span", { yPercent: 0 })
    .to("form", { xPercent: 0, opacity: 1 });
}
